{
  "attachAria": "Anexar arquivo",
  "emptyHint": "Descreva o problema — o suporte responderá aqui",
  "emptyTitle": "Ainda não há mensagens",
  "fileOpenAria": "Abrir anexo",
  "logAria": "Conversa da solicitação",
  "newMessages": "Novas mensagens",
  "placeholder": "Escreva uma mensagem…",
  "placeholderDisabled": "As mensagens estão temporariamente indisponíveis",
  "previewAria": "Ver anexo",
  "previewCloseAria": "Fechar pré-visualização",
  "removeAttachmentAria": "Remover arquivo",
  "retry": "Tentar novamente",
  "screenshotAria": "Fazer uma captura de tela",
  "seen": "Visto",
  "sendAria": "Enviar mensagem",
  "sendFailed": "Não foi possível enviar a mensagem",
  "sending": "Enviando…",
  "student": "Aluno",
  "supportName": "Suporte Skyeng",
  "today": "Hoje",
  "yesterday": "Ontem",
  "you": "Você"
}
